import { useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { pl } from 'date-fns/locale';
import {
  activateUserRequest,
  adminGetAllUsersRequest,
  deactivateUserRequest,
  deleteUserRequest,
  setUserToAdminRequest,
  unsetUserFromAdminRequest
} from '../../actions/admin';
import { useAppDispatch, useAppSelector } from '../../hooks';

export default function Users() {
  const dispatch = useAppDispatch();
  const users = useAppSelector((s) => s.admin.users);

  useEffect(() => {
    dispatch(adminGetAllUsersRequest());
  }, [dispatch]);

  const confirmThen = (question: string, action: unknown) => () => {
    if (window.confirm(question)) {
      dispatch(action as never);
    }
  };

  return (
    <div>
      <table className="usersList">
        <tbody>
          <tr>
            <th>E-mail</th>
            <th>Imię</th>
            <th>Ostatnio aktywny</th>
            <th>Aktywny?</th>
            <th>Admin?</th>
            <th>Usuń?</th>
          </tr>
          {users.map((user) => {
            const email = user.username ?? '';
            return (
              <tr key={user._id}>
                <td>{email}</td>
                <td>{user.name}</td>
                <td>
                  {user.dateLastActive
                    ? (
                      <span className="dateActive">
                        {formatDistanceToNow(new Date(user.dateLastActive), { locale: pl, addSuffix: true })}
                      </span>
                    )
                    : <span className="neverActive">nigdy</span>}
                </td>
                <td>
                  {user.isActive
                    ? (
                      <button
                        type="button"
                        className="deactivate"
                        onClick={confirmThen(
                          `Czy jesteś pewny, że chcesz deaktywować użytkownika ${email}`,
                          deactivateUserRequest(user.short)
                        )}
                      >Tak</button>
                    )
                    : (
                      <button
                        type="button"
                        className="activate"
                        onClick={confirmThen(
                          `Czy jesteś pewny, że chcesz dać aktywować użytkownika ${email}`,
                          activateUserRequest(user.short)
                        )}
                      >Nie</button>
                    )}
                </td>
                <td>
                  {user.isAdmin
                    ? (
                      <button
                        type="button"
                        className="removeAdmin"
                        onClick={confirmThen(
                          `Czy jesteś pewny, że chcesz usunąć admina użytkownikowi ${email}`,
                          unsetUserFromAdminRequest(user.short)
                        )}
                      >Tak</button>
                    )
                    : (
                      <button
                        type="button"
                        className="makeAdmin"
                        onClick={confirmThen(
                          `Czy jesteś pewny, że chcesz dać admina użytkownikowi ${email}`,
                          setUserToAdminRequest(user.short)
                        )}
                      >Nie</button>
                    )}
                </td>
                <td>
                  <button
                    type="button"
                    className="removeUser"
                    onClick={confirmThen(
                      `Czy jesteś pewny, że chcesz usunąć użytkownikowa ${email}`,
                      deleteUserRequest(user.short)
                    )}
                  >Usuń</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {users.length === 0 && <div className="loading">Trwa ładowanie</div>}
    </div>
  );
}
